import { createContext, useContext } from "react";
import { Language, TranslationKey } from "./translations";

export type TranslateVars = Record<string, string | number>;

export type I18n = {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (key: TranslationKey, vars?: TranslateVars) => string;
};

export const I18nContext = createContext<I18n | null>(null);

export function useI18n(): I18n {
  const ctx = useContext(I18nContext);
  if (!ctx) {
    throw new Error("useI18n must be used within a LanguageProvider");
  }
  return ctx;
}
